import { render, staticRenderFns } from "./Headline.vue?vue&type=template&id=6bce19dc&scoped=true&"
var script = {}
import style0 from "./Headline.vue?vue&type=style&index=0&id=6bce19dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bce19dc",
  null
  
)

export default component.exports